<template>
  <div class="w-full p-6 space-y-10">
    <div class="w-full border rounded-lg p-6 border-mid-neutral-50 bg-white">
      <div class="flex w-full gap-8 pb-6">
        <div class="w-1/4 space-y-1">
          <h3 class="font-semibold text-dark-neutral-500">
            Specify the strategy
          </h3>
          <p class="text-sm text-gray-600 font-light">
            Describe the search approach to identify relevant records.
          </p>
        </div>
        <div class="w-full">
          <PlanLockGuard>
            <TextInput
              v-model="searchStrategySummary"
              placeholder="Summarize search strategy"
              type="text"
              input-classes="w-full pl-5 py-5 min-h-[200px] text-sm hover:border-mid-neutral-50 focus:border-mid-neutral-50"
              :multiline="true"
              :can-resize="true"
              :disabled="review.isPlanReadonly.value"
              @blur="(v) => updateSearchStrategySummary(v)"
              @enter="(v) => updateSearchStrategySummary(v)"
            />
          </PlanLockGuard>
        </div>
      </div>
      <InclusionCriteria />
      <PlanScreening />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import TextInput from '@app/components/Global/Inputs/TextInput.vue'
import InclusionCriteria from './InclusionCriteria/InclusionCriteria.vue'
import PlanScreening from './PlanScreening/PlanScreening.vue'
import PlanLockGuard from '../PlanLockGuard.vue'
import useSnackbar from '@app/composables/use-snackbar'
import useLoading from '@app/composables/use-loading'
import { SnackbarState } from '@app/types'
import { HttpException } from '@core/exceptions/http.exception'
import { errorMessage } from '@app/utils/error-message'
import { injectStrict } from '@app/utils/injectStrict'
import { ReviewKey } from '../../use-review'

const review = injectStrict(ReviewKey)
const snackbar = useSnackbar()
const loading = useLoading()

const searchStrategySummary = ref(
  review.entity.value.plan?.searchStrategySummary,
)

async function updateSearchStrategySummary(newSearchStrategy: string) {
  try {
    loading.start()
    await review.updateSearchStrategySummary(newSearchStrategy)
    snackbar.success('Success')
  } catch (e) {
    const error = e as HttpException
    snackbar.show(SnackbarState.ERROR, errorMessage(error.response.data))

    if (error.response.data.statusCode >= 500) {
      throw e
    }
  } finally {
    loading.stop()
  }
}
</script>
